<div class="pagecontent">
    <h1 class="header1">Request Type</h1>
    <h2 class="header2">What type of request was it?</h2>
    <div class="radio-container">
        <mat-radio-group aria-label="Select an option" (change)="onSelectionChange($event)">
            <div class="pre-trip-option">
              <mat-radio-button value="Pre">Pre-Trip Authorization</mat-radio-button>
              <button class="pre-trip-description" mat-icon-button aria-label="Pre Trip Description" (click)="showPreTripText()">
                  <mat-icon>{{displayPreTripText ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </div>
            @if(!preTripFlag) {
              <mat-radio-button value="Post">Post-Trip Reimbursement Request</mat-radio-button>
            }
        </mat-radio-group>
    </div>
    @if(preTripFlag) {
      <div class="pre-trip-message">
          <span>Pre-trip authorization is required for all appointments.</span>
      </div>
    }
    <div class="button-row">
        <button class="trip-button" type="button" [disabled]="tripRequestType === ''" matInput  mat-button (click)="goToTripRequest()">Enter Trip Details</button>
    </div>

    @if (displayPreTripText) {
    <div [ngClass]="isMobileView() ? 'pre-trip-text-mobile-container' : 'pre-trip-text-desktop-container'">
      <span>A pre-trip authorization is defined by the following situations (but not limited to):</span>
      <div class="pre-trip-sub-text">
        <span>- The consumer is in their first quarter of MATP service utilizing mileage reimbursement.</span>
        <span>- The consumer is suspected of having engaged in fraud, waste, or abuse activities, indicated by the previous forms submitted that contained errors or inconsistencies.</span>
        <span>- The consumer is planning a trip beyond the Community identified by the Administrator in their Administrator Profile.</span>
      </div>
    </div>
  }

</div>

<ng-template #confirmationDialogTemplate>
  <div class="access-dialogue">
    <div mat-dialog-title class="dialog-title-center">
        <span>Pre-Trip Request Confirmation</span>
    </div>
    <mat-dialog-content>
      <p>Pre-trip authorization is not required for this request. Do you want to continue?</p>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions-center">
      <button mat-flat-button [mat-dialog-close]="false" aria-label="Cancel the action">Cancel</button>  
      <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial aria-label="Continue to next step">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>

